

















































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import eventBus from '@/utils/eventBus';
import HTTPStatus from '@/constants/httpStatus';
import { ILocation } from '@/models/location';
import ConfirmationDelete from '@/componentsV2/templates/Modals/InviteMerchantSignup/ConfirmationDelete.vue';
import InviteMerchantSignupModalsModel from '@/views/Models/InviteMerchantSignupModalsModel.vue';

@Component({
  components: {
    Typography,
    ConfirmationDelete
  }
})
export default class ConfirmationDeleteLocation extends Mixins(
  Vue,
  InviteMerchantSignupModalsModel
) {
  @Prop() readonly code!: string;
  @Prop() location!: ILocation;

  loading = false;

  onClose() {
    eventBus.$emit('closeModal');
  }

  phoneMask(phone?: string) {
    if (!phone) return '--';
    return phone.replace(/^(\d{3})(\d{3})(\d+)$/, '($1) $2-$3');
  }

  async handleDeleteLocation() {
    this.loading = true;

    const { status } = await this.service.deleteLocation(
      this.code,
      this.location.id
    );

    if (status === HTTPStatus.OK) {
      this.$notification('The Location has been removed!', 'success');
      eventBus.$emit('inviteMerchantLocationRemoved', this.location.id);
    }

    this.loading = false;
    this.onClose();
  }
}
